import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/address`;

export default {
  async list() {
    let apiUrl = store.state.countrySelected.api;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/list`);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
